import React from "react";
// used for making the prop types of this component
// import PropTypes from "prop-types";

class TableCalculator extends React.Component {


  calculate(values) {
    let total = 0
    let disountRate = 0
    let taxRate = 0
    let totalNeedTax = 0
    let totalNeedDiscount = 0
    let discount = 0
    let tax = 0
    let subTotal

    let list = values

    if (values && values.list) {
      list = values.list
    }

    if (list) {
      for (let i = 0; i < list.length; i++) {
        const value = list[i];
        // console.log(value)
        if (!value.tax && !value.discount) {
          total = total + Number(value.amount)
          if (!value.taxFree) {
            totalNeedTax = totalNeedTax + Number(value.amount)
          }
          if (!value.discountFree) {
            totalNeedDiscount = totalNeedDiscount + Number(value.amount)
          }
        }
        if (value.tax) {
          if (typeof value.amount == "string") {
            taxRate = Number(value.amount.replace('%', '')) / 100
          } else {
            taxRate = Number(value.amount) / 100
          }
        }
        if (value.discount) {
          if (typeof value.amount == "string") {
            disountRate = Number(value.amount.replace('%', '')) / 100
          } else {
            disountRate = Number(value.amount) / 100
          }
        }
      }

      subTotal = total
      discount = (totalNeedDiscount * disountRate)
      tax = ((totalNeedTax - discount) * taxRate)

      total = total - discount + tax
    }

    return { total, subTotal, discount, tax }

  }

  render() {
    return (
      <div className='text-center '>

        <p className="" >{this.calculate(this.props.fullValues?.values ? this.props.fullValues.values : this.props.fullValues).total.toFixed(2)}</p>

      </div>
    );
  }
}

export default TableCalculator;
